import { Trans } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";

import { Dialog, DialogHeader } from "../../../components/ui-kit/dialog";
import { AdminConsole } from "../admin-console";
import { AddClinicForm } from "./add-clinic-form";

export const AddClinicDialog = observer(function AddClinicDialog({
  admin,
  onClose,
  onSaved,
}: {
  admin: AdminConsole;
  onClose: () => void;
  onSaved: () => void;
}) {
  return (
    <Dialog open onOpenChange={(open) => !open && onClose()}>
      <DialogHeader>
        <Trans>Add new clinic</Trans>
      </DialogHeader>
      <AddClinicForm
        admin={admin}
        onCancel={onClose}
        onSuccess={() => {
          onSaved();
          onClose();
        }}
      />
    </Dialog>
  );
});
